import React from 'react';

export interface CarritoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CarritoIcon: React.FC<CarritoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.333 1.662h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61l1.6-8.39h-17m4 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.662h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default CarritoIcon;
